import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, FileText } from 'lucide-react';
import { openWhatsApp, DEFAULT_WA_MESSAGE } from '../lib/wa';

// Floating WhatsApp (all screens) + sticky mobile action bar
const StickyActions = () => {
  return (
    <>
      {/* Floating WhatsApp */}
      <button
        type="button"
        onClick={() => openWhatsApp(DEFAULT_WA_MESSAGE)}
        aria-label="Chat with us on WhatsApp"
        data-testid="floating-whatsapp-button"
        className="ktc-chrome fixed z-40 bottom-24 right-5 md:bottom-6 md:right-6 h-14 w-14 grid place-items-center rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform"
      >
        <MessageCircle size={26} />
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" />
      </button>

      {/* Sticky mobile bottom bar */}
      <div className="ktc-chrome md:hidden fixed z-40 bottom-0 inset-x-0 bg-ktc-ivoryLight border-t border-ktc-cream shadow-[0_-6px_24px_-12px_rgba(15,51,32,0.35)] grid grid-cols-2">
        <button
          type="button"
          onClick={() => openWhatsApp(DEFAULT_WA_MESSAGE)}
          data-testid="mobile-whatsapp-button"
          className="flex items-center justify-center gap-2 py-3.5 text-[#128C7E] font-medium text-sm"
        >
          <MessageCircle size={18} /> WhatsApp
        </button>
        <Link to="/quote" className="flex items-center justify-center gap-2 py-3.5 bg-ktc-green text-ktc-ivory font-medium text-sm">
          <FileText size={18} /> Request Quote
        </Link>
      </div>
    </>
  );
};

export default StickyActions;
